import { FormattedMessage } from 'react-intl';
import { useFela } from 'react-fela';

import { upperFirst as _upperFirst } from 'lodash';

import config from 'config/config';

import LoginForm from '../../containers/LoginForm';

import rule from './LoginPage.rule';

const LoginPage = () => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <img src={config.app.brand.images.logo} alt={_upperFirst(config.app.name)} />
            <h1>
                <FormattedMessage id="app.title" values={{ appName: _upperFirst(config.app.name) }} />
            </h1>
            <LoginForm />
        </div>
    );
};
export default LoginPage;
